import ahmedabad from './ahmedabad.png'
import bengaluru from './bengaluru.png'
import chandigarh from './chandigarh.png'
import chennai from './chennai.png'
import delhi from './delhi.png'
import hyderabad from './hyderabad.png'
import kochi from './kochi.png'
import kolkata from './kolkata.png'
import mumbai from './mumbai.png'
import pune from './pune.png'


export const CityIcons = {
    ahmedabad, bengaluru, chandigarh, chennai, delhi, hyderabad, kochi, kolkata, mumbai, pune
}